import type { PipeTransform } from "@angular/core";
import { Pipe } from "@angular/core";

@Pipe({
    name: 'arraySort',
    standalone: true
}) export class ArraySortPipe implements PipeTransform {

    transform(value: any[], sortFn: (a: any, b: any) => number) {
        if (!value) {
            return [];
        }
        return [...value].sort(sortFn);
    }

}